import FlatsForm from '@features/flats/components/FlatsForm'
import { useUpdateFlat } from '@services/flats/mutations/useUpdateFlat'
import { FlatWrite } from '@services/flats/types'
import { useState } from 'react'
import { FlatDetail } from 'types/api'

export function FlatsEdit({ data: initialData }: { data: FlatDetail }) {
  const [formData, setFormData] = useState(initialData)
  const { mutate: submitFlat, isPending } = useUpdateFlat()

  const handleSubmit = (values: FlatWrite) => {
    submitFlat({
      id: initialData.id,
      body: values,
      params: {
        onSuccess: (updatedData) => {
          setFormData(updatedData)
        }
      }
    })
  }

  // Keep the form mounted while saving — FlatsForm shows the spinner on its
  // submit button (no full-page loader swap that would reset scroll).
  return (
    <FlatsForm data={formData} handleSubmit={handleSubmit} isLoading={isPending} />
  )
}
